import { useQuery } from "@tanstack/react-query";
import { fetchCompany } from "../services/companiesServices";

const useCompany = (companyID) => {
  return useQuery({
    queryKey: ["company", companyID],
    queryFn: () => fetchCompany(companyID),
    enabled: !!companyID,
  });
};

export default useCompany;
